import { useAccountingStore } from '@/stores/accounting';
import ROUTES from '@/utils/constants/accounting/routes_names';
import USER_PERMISSIONS from '@/utils/constants/accounting/permissions_aliases';

const actions = [
    {
        routeName: ROUTES.AR_DEPOSITS.name,
        items: [
            {
                title: 'add deposit',
                routeName: ROUTES.AR_DEPOSITS_ADD_NEW.name,
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_ADD_DEPOSIT);
                },
            },
        ],
    },
    {
        routeName: ROUTES.AR_RESIDENT_DEPOSITS.name,
        items: [
            {
                title: 'add deposit',
                routeName: ROUTES.AR_RESIDENT_DEPOSITS_ADD_NEW.name,
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_POST_DEPOSITS);
                },
            },
        ],
    },
];

export default actions;
